<template>
    <b-dropdown
        ref="dropdown"
        class="lang-dropdown"
        size="sm"
        variant="link"
        toggle-class="btn btn-clean btn-dropdown btn-lg mr-1 text-decoration-none d-inline-flex align-items-center"
        no-caret
        no-flip
        :right="right"
    >
        <template v-slot:button-content>
            <img
                class="h-20px w-20px rounded-sm"
                :src="language.flag"
                :alt="language.name"
            />
            <b-icon-chevron-down class="ml-2 flex-shrink-0"></b-icon-chevron-down>
        </template>
        <b-dropdown-text tag="div" text-class="p-0">
            <ul class="navi navi-hover">
                <template v-for="(item, i) in languages">
                    <li
                        class="navi-item"
                        :class="{ 'navi-item-active': isActiveLanguage(item.lang) }"
                        :key="i"
                    >
                        <a
                            href="#"
                            class="navi-link"
                            :lang="item.lang"
                            :aria-current="isActiveLanguage(item.lang) ? 'true' : null"
                            @click.prevent="selectedLanguage(item.lang)"
                        >
                    <span class="symbol symbol-20 mr-3">
                        <img :src="item.flag" alt="" />
                    </span>
                            <span class="navi-text">{{ item.name }}</span>
                        </a>
                    </li>
                </template>
            </ul>
        </b-dropdown-text>
    </b-dropdown>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import i18nService from '@/shared/services/i18n.service.js';
    import { REQUEST_LANGUAGE_SWITCH } from '@/modules/auth/auth-store';
    import { BIconChevronDown } from 'bootstrap-vue';

    export default {
        name: 'LanguageSelect',
        components: {
            BIconChevronDown,
        },
        props: {
            persist: {
                type: Boolean,
                default: true,
            },
            right: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                languages: i18nService.languages,
                activeLanguage: i18nService.getActiveLanguage(),
            };
        },
        computed: {
            ...mapGetters({
                isAuthenticated: 'auth/isAuthenticated',
            }),
            language() {
                return (
                    this.languages.find((val) => val.lang === this.activeLanguage) ||
                    this.languages.find((val) => val.lang === i18nService.defaultLanguage)
                );
            },
        },
        watch: {
            '$i18n.locale'(locale) {
                this.activeLanguage = locale;
            },
        },
        methods: {
            ...mapActions({
                requestLanguageSwitch: `auth/${REQUEST_LANGUAGE_SWITCH}`,
            }),
            selectedLanguage(lang) {
                if (lang === this.activeLanguage) {
                    return;
                }

                if (this.persist && this.isAuthenticated) {
                    this.$refs.dropdown.hide();
                    this.requestLanguageSwitch(lang);
                    return;
                }

                if (!this.persist) {
                    // The verification pages' guards depend on in-memory auth state that a reload purges.
                    try {
                        i18nService.setActiveLanguage(lang);
                    } catch (error) {
                        console.error('[language] switch failed', error?.message);
                        return;
                    }
                    this.$i18n.locale = lang;
                    this.activeLanguage = lang;
                    return;
                }

                i18nService.setActiveLanguage(lang);
                window.location.reload();
            },
            isActiveLanguage(current) {
                return this.activeLanguage === current;
            },
        },
    };
</script>
